import { useEffect } from "react";
import { isNative, initAd, ensureBanner } from "../lib/ad";

const GlobalBanner = () => {
  useEffect(() => {
    if (!isNative()) return;

    let alive = true;

    initAd().then(() => {
      if (!alive) return;
      ensureBanner().catch(() => {});
    });

    // ❌ 여기서 hideBanner 절대 호출하지 말 것
    return () => {
      alive = false;
    };
  }, []);

  return null;
};

export default GlobalBanner;
